var _rect, _circle, _circle2, _circle3, _polyline, _circle4, _circle5, _circle6, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgovexLockupTaglineDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 88,
    viewBox: "0 0 320 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 88,
    fill: "#0d1117"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27,
    stroke: "#1e2a2a",
    strokeWidth: 1,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27,
    stroke: "#00d4aa",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "42 128",
    strokeDashoffset: -18,
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 27,
    stroke: "#00d4aa",
    strokeWidth: 1.5,
    fill: "none",
    strokeDasharray: "21 149",
    strokeDashoffset: -75,
    opacity: 0.35
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "13,36 21,36 25,24 31,47 36,29 41,41 45,32 51,32 56,36 59,36",
    stroke: "#00d4aa",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 3,
    fill: "#0d1117"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 3,
    stroke: "#00d4aa",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 1.2,
    fill: "#00d4aa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 42,
    fontFamily: "Oxanium, sans-serif",
    fontWeight: 800,
    fontSize: 30,
    letterSpacing: -0.5
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#e6edf3"
  }, "algo"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#00d4aa"
  }, "vex"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 81,
    y: 62,
    fontFamily: "JetBrains Mono, monospace",
    fontWeight: 400,
    fontSize: 11,
    letterSpacing: 1.2,
    fill: "#8b949e"
  }, "AI-POWERED STRATEGY BACKTESTING")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgovexLockupTaglineDark);
export default __webpack_public_path__ + "static/media/algovex-lockup-tagline-dark.1db18b50b0da4c64226e8436f57f2992.svg";
export { ForwardRef as ReactComponent };